import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { RootReducerState } from '../../redux/Reducers';
import { GlobalRoleAssignment } from '../../types/permissions/global-role-assignment.type';
import { GlobalRoleItem } from '../../types/permissions/global-role.type';
import { OrgRoleAssignment } from '../../types/permissions/org-role-assignment.type';
import { OrgRoleItem } from '../../types/permissions/org-role.type';
import { PaginationType } from '../../types/utils/pagination.type';
import { rejectWithApiError } from '../../utils/api';
import { additionalQueryParams } from '../../utils/utilities';
import {
  GlobalRoleAssignmentsRouteParams,
  GlobalRolesListRouteParams,
  OrgRoleAssignmentsRouteParams,
  OrgRolesListRouteParams,
} from './permissions.slice';

export const getOrgRolesList = createAsyncThunk<
  PaginationType<OrgRoleItem>,
  OrgRolesListRouteParams & { controller?: AbortController },
  { state: RootReducerState; rejectValue: string }
>('permissions/getOrgRolesList', async (data, thunkAPI) => {
  try {
    const { controller, ...params } = data;
    const additionalParams = additionalQueryParams(
      thunkAPI.getState().sharedReducer.selectedCompany,
      null,
      thunkAPI.getState().sharedReducer.includeSuborgs
    );
    const response = await axios.get<PaginationType<OrgRoleItem>>(
      `${process.env.REACT_APP_API_URL}/permissions/org/roles`,
      {
        params: { ...params, ...additionalParams },
        signal: controller?.signal,
      }
    );
    return response.data;
  } catch (error) {
    return rejectWithApiError({ thunkAPI, error });
  }
});

export const getOrgRoleAssignments = createAsyncThunk<
  PaginationType<OrgRoleAssignment>,
  OrgRoleAssignmentsRouteParams & { user_id?: number; role_id?: number; controller?: AbortController },
  { state: RootReducerState; rejectValue: string }
>('permissions/getOrgRoleAssignments', async (data, thunkAPI) => {
  try {
    const { controller, ...params } = data;
    const additionalParams = additionalQueryParams(
      thunkAPI.getState().sharedReducer.selectedCompany,
      null,
      thunkAPI.getState().sharedReducer.includeSuborgs
    );
    const result = await axios.get<PaginationType<OrgRoleAssignment>>(
      `${process.env.REACT_APP_API_URL}/permissions/org/assignments`,
      { params: { ...params, ...additionalParams }, signal: controller?.signal }
    );
    return result.data;
  } catch (error) {
    return rejectWithApiError({ thunkAPI, error });
  }
});

export const getGlobalRolesList = createAsyncThunk<
  PaginationType<GlobalRoleItem>,
  GlobalRolesListRouteParams & { controller?: AbortController },
  { state: RootReducerState; rejectValue: string }
>('permissions/getGlobalRolesList', async (data, thunkAPI) => {
  try {
    const { controller, ...params } = data;
    const response = await axios.get<PaginationType<GlobalRoleItem>>(
      `${process.env.REACT_APP_API_URL}/permissions/global/roles`,
      {
        params,
        signal: controller?.signal,
      }
    );
    return response.data;
  } catch (error) {
    return rejectWithApiError({ thunkAPI, error });
  }
});

export const getGlobalRoleAssignments = createAsyncThunk<
  PaginationType<GlobalRoleAssignment>,
  GlobalRoleAssignmentsRouteParams & { user_id?: number; role_id?: number; controller?: AbortController },
  { state: RootReducerState; rejectValue: string }
>('permissions/getGlobalRoleAssignments', async (data, thunkAPI) => {
  try {
    const { controller, ...params } = data;
    const result = await axios.get<PaginationType<GlobalRoleAssignment>>(
      `${process.env.REACT_APP_API_URL}/permissions/global/assignments`,
      { params, signal: controller?.signal }
    );
    return result.data;
  } catch (error) {
    return rejectWithApiError({ thunkAPI, error });
  }
});
